import { action } from 'satcheljs';

export const validateDumpsterQuota = action('TRY_VALIDATE_DUMPSTER_QUOTA');
